/**
 * AI 생성 진입 카드 묶음 — 「AI로 문제 만들기」 머리 + [주제로 만들기 ›][자료로 만들기 ›].
 * 순수 UI 다. Figma `.AI 생성/진입 바`·`.AI 생성/선택 카드`.
 * - 크기: 빈 퀴즈는 크게, 문제가 있으면 작게. 모바일은 늘 크게, 세로 1열(BuildEntryCard).
 * - 높게(tall): 빈 퀴즈에 문제 은행 카드도 없어 두 장만 남으면 카드를 200 으로 높인다(Figma 41092:29118, tablet-sm 이상).
 * - 문제 은행 카드는 AI 기능이 아니라 여기 두지 않는다 — 빌드 화면(BuildStepQuiz)이 같은 위계로 둔다.
 */
import { PlanBadge } from '@/shared/components/Badge/PlanBadge';
import { cn } from '@/utils/tailwind.util';
import { BuildEntryCard, type BuildEntryCardSize } from '../../../components/BuildEntryCard';
import { type AiGenerateEntryCopy } from '../types/aiGenerateDock.types';
import { SourceLogoRollPicture, TopicInputPicture } from './AiGenerateEntryPictures';
export type AiGenerateEntryCardsUIProps = {
  copy: AiGenerateEntryCopy;
  /** 빈 퀴즈면 크게. */
  size: BuildEntryCardSize;
  /** 카드 높이만 키운다 — 호출부가 「아래 다른 진입 카드가 없을 때」 켠다. */
  tall?: boolean;
  /** AI 셸(채팅 패널 열림)에서는 2열 전환 폭이 1025px 이다. */
  layoutMode?: 'page' | 'ai-shell';
  onSelectTopic: () => void;
  onSelectSource: () => void;
};
export const AiGenerateEntryCardsUI = ({
  copy,
  size,
  tall = false,
  layoutMode = 'page',
  onSelectTopic,
  onSelectSource
}: AiGenerateEntryCardsUIProps) => <section data-testid="ai-generate-entry" data-size={size} aria-label={copy.title} className="flex w-full flex-col gap-xs" data-sentry-component="AiGenerateEntryCardsUI" data-sentry-source-file="AiGenerateEntryCardsUI.tsx">
    <div className="flex items-center gap-2xs px-4xs">
      <img src="/assets/ai_face.png" alt="" width={24} height={24} />
      <h2 className="text-body-lg-bold text-default">{copy.title}</h2>
      <PlanBadge planType="BASIC" tooltip={false} className="size-[18px]" data-sentry-element="PlanBadge" data-sentry-source-file="AiGenerateEntryCardsUI.tsx" />
    </div>
    <div className={cn('grid grid-cols-1 gap-x-sm gap-y-xs', layoutMode === 'ai-shell' ? 'min-[1025px]:grid-cols-2' : 'tablet-sm:grid-cols-2')}>
      <BuildEntryCard testId="ai-generate-entry-topic" title={copy.topic} size={size} tall={tall} onClick={onSelectTopic} data-sentry-element="BuildEntryCard" data-sentry-source-file="AiGenerateEntryCardsUI.tsx">
        <TopicInputPicture samples={copy.topicSamples} size={size} data-sentry-element="TopicInputPicture" data-sentry-source-file="AiGenerateEntryCardsUI.tsx" />
      </BuildEntryCard>
      <BuildEntryCard testId="ai-generate-entry-source" title={copy.source} size={size} tall={tall} onClick={onSelectSource} data-sentry-element="BuildEntryCard" data-sentry-source-file="AiGenerateEntryCardsUI.tsx">
        <SourceLogoRollPicture size={size} data-sentry-element="SourceLogoRollPicture" data-sentry-source-file="AiGenerateEntryCardsUI.tsx" />
      </BuildEntryCard>
    </div>
  </section>;